/* snap-enhance.js — robustes Snap-Scrolling, exakt nach Preview-Source-Logik.
   Komplementiert das Bundle: wendet die snap-Klassen zuverlässig an (mit Retry
   bei async-Render) + repliziert die per-Page-Verfeinerungen 1:1. */
(function () {
  var SNAP_PAGES = ['home', 'zen', 'tukkon', 'about'];
  var HERO_SEL = '.hero-video,.zenroom-hero,.about-hero';
  var SECT_SEL = '.zenroom,.zen-gallery,.quote,.split,.instagram-section,.tukkon-lifestyle,.tukkon-vogue,.tukkon-character,.tukkon-brass,.tukkon-cta,.manifesto,.about-process';

  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function guardExpandableMenuLink(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a.om-link-expandable');
    if (!link) return;
    event.preventDefault();
    link.removeAttribute('href');
  }

  document.addEventListener('click', guardExpandableMenuLink, true);

  function clearSnap() {
    var sc = document.scrollingElement || document.documentElement;
    qsa('.snap-hero,.snap-section').forEach(function (el) { el.classList.remove('snap-hero', 'snap-section'); });
    sc.style.scrollSnapType = '';
    sc.style.scrollPaddingTop = '';
  }

  function applySnap() {
    var page = document.body.getAttribute('data-page') || 'home';
    var sc = document.scrollingElement || document.documentElement;

    // Erst immer sauber zurücksetzen (wie Preview)
    qsa('.snap-hero,.snap-section').forEach(function (el) { el.classList.remove('snap-hero', 'snap-section'); });
    sc.style.scrollSnapType = '';
    sc.style.scrollPaddingTop = '';

    if (SNAP_PAGES.indexOf(page) === -1 || window.innerWidth <= 900) {
      return -1; // nicht anwendbar (mobile oder andere Seite) — kein Retry nötig
    }

    var nav = document.querySelector('nav.nav');
    var navH = nav ? nav.offsetHeight : 72;
    sc.style.scrollSnapType = 'y proximity';
    sc.style.scrollPaddingTop = navH + 'px';

    // 1. Basis: Hero + Sections (inkl. .quote)
    var heroEls = qsa(HERO_SEL);
    heroEls.forEach(function (el) { el.classList.add('snap-hero'); });
    var sectEls = qsa(SECT_SEL);
    sectEls.forEach(function (el) { el.classList.add('snap-section'); });

    // 2. home: erste 3 .sect zusätzlich snappen
    if (page === 'home') {
      var sects = qsa('.sect');
      if (sects[0]) sects[0].classList.add('snap-section');
      if (sects[1]) sects[1].classList.add('snap-section');
      if (sects[2]) sects[2].classList.add('snap-section');
    }
    // 3. about + home: .quote NICHT snappen
    if (page === 'about' || page === 'home') {
      qsa('.quote').forEach(function (el) { el.classList.remove('snap-section'); });
    }
    // 4. zen + tukkon: ALLE .sect snappen
    if (page === 'zen' || page === 'tukkon') {
      qsa('.sect').forEach(function (el) { el.classList.add('snap-section'); });
    }

    return heroEls.length + sectEls.length; // >0 = Elemente da, kein Retry mehr nötig
  }

  function applyWithRetry(attempts) {
    attempts = attempts || 0;
    var count = applySnap();
    // count === 0: anwendbare Seite, aber Elemente noch nicht gerendert → retry
    if (count === 0 && attempts < 24) {
      setTimeout(function () { applyWithRetry(attempts + 1); }, 250);
    }
  }

  function boot() {
    applyWithRetry(0);
    var lastPage = document.body.getAttribute('data-page');
    var obs = new MutationObserver(function () {
      var p = document.body.getAttribute('data-page');
      if (p !== lastPage) { lastPage = p; applyWithRetry(0); }
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['data-page'] });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { applySnap(); }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
